import getNaiveObjectSize from './getNaiveObjectSize';

type RecordIterator = (key: unknown, value: unknown) => void;

const getRecordSizesClosure = () => {
  const recordSizes: Map<unknown, number> = new Map<unknown, number>();
  const getRecordCallback = (key: unknown, value: unknown) =>
    recordSizes.set(key, getNaiveObjectSize(value));
  return { recordSizes, getRecordCallback };
};

export const getRecordSizes = (
  getAllRecords: (callback: RecordIterator) => void
): Map<unknown, number> => {
  const { recordSizes, getRecordCallback } = getRecordSizesClosure();
  getAllRecords(getRecordCallback);
  return recordSizes;
};

export const getRecordSizesAsync = (
  getAllRecords: (callback: RecordIterator) => Promise<void>
): Promise<Map<unknown, number>> => {
  const { recordSizes, getRecordCallback } = getRecordSizesClosure();
  return getAllRecords(getRecordCallback).then(() => recordSizes);
};
